import { render, staticRenderFns } from "./BaseList.vue?vue&type=template&id=4fb335c4&scoped=true&"
import script from "./BaseList.vue?vue&type=script&lang=js&"
export * from "./BaseList.vue?vue&type=script&lang=js&"
import style0 from "./BaseList.vue?vue&type=style&index=0&id=4fb335c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb335c4",
  null
  
)

export default component.exports